import { useEffect, useCallback } from "react";
import { Capacitor } from "@capacitor/core";
import { useNavigate } from "react-router-dom";

/**
 * Hook to set up iOS Quick Actions (3D Touch / Haptic Touch shortcuts)
 * Must be used inside a router context
 */
export function useQuickActions() {
  const navigate = useNavigate();

  // Set up quick actions on mount
  const setupQuickActions = useCallback(async () => {
    if (!Capacitor.isNativePlatform()) return;

    try {
      const { AppShortcuts } = await import("@capawesome/capacitor-app-shortcuts");

      // Define the quick actions with SF Symbols icons for iOS
      await AppShortcuts.set({
        shortcuts: [
          {
            id: "scan",
            title: "Scanner",
            description: "Scanner un document",
            iosIcon: "doc.viewfinder", // SF Symbol for document scanner
          },
          {
            id: "search",
            title: "Rechercher",
            description: "Rechercher un document",
            iosIcon: "magnifyingglass", // SF Symbol for search
          },
          {
            id: "upload",
            title: "Ajouter",
            description: "Ajouter un document",
            iosIcon: "plus.circle.fill", // SF Symbol for add
          },
        ],
      });

      // Listen for quick action clicks
      AppShortcuts.addListener("click", (event) => {
        console.log("[QuickActions] Shortcut clicked:", event.shortcutId);
        
        switch (event.shortcutId) {
          case "scan":
            navigate("/pdf-tools");
            break;
          case "search":
            navigate("/documents");
            break;
          case "upload":
            navigate("/documents");
            break;
          default:
            navigate("/documents");
        }
      });
    } catch (error) {
      console.error("Failed to set up quick actions:", error);
    }
  }, [navigate]);

  useEffect(() => {
    setupQuickActions();
  }, [setupQuickActions]);
}
